import { createSlice } from '@reduxjs/toolkit';
import { getCalendarData } from '../actions/calendarActions';
import { TransformDate } from '../../components/DatePicker/DatePickerUtils/datePickerUtils';

let formattedData;
let formattedDataWithDate;
try {
  formattedData = JSON.parse(localStorage.getItem('transformedData'));
  formattedDataWithDate = JSON.parse(localStorage.getItem('transformedDataWithDate'));
} catch {}
const initialState = {
  type: 'calendar',
  loading: false,
  calendarData: [],
  calendarDataWithDate: [],
  formattedData: formattedData || [],
  formattedDataWithDate: formattedDataWithDate || [],
  selectedYear: '',
  selectedQuarter: '',
  comparisonYear: '',
  comparisonQuarter: '',
  quarterList: [],
  quarterCompareList: [],
  quarterMenuList: [],
  quarterMenuListForCompare: [],
  yearMenuList: [],
  yearMenuListForCompare: [],
  boundaryValue: {
    startingYear: '',
    endingYear: '',
    endingQuarter: '',
  },
  boundaryValueForCompare: {
    startingYear: '',
    endingYear: '',
    endingQuarter: '',
  },
  calendarDt: {},
};

const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    getCalendar: (state, action) => {
      state.calendarData = action.payload;
    },
    getCalendarWithDate: (state, action) => {
      state.calendarDataWithDate = action.payload;
    },
    transformData: (state, action) => {
      const processedData = TransformDate.sortRawFormattedData(action.payload);
      const calendarYear = processedData[0];
      localStorage.setItem('transformedData', JSON.stringify(processedData));
      return {
        ...state,
        formattedData: processedData,
        calendarDt: {
          calendarYear,
          processedDatesLength: processedData?.length,
        },
      };
    },
    transformDataWithDate: (state, action) => {
      const processedData = TransformDate.formatRawDataWithDates(action.payload);
      localStorage.setItem('transformDataWithDate', JSON.stringify(processedData));
      return { ...state, formattedDataWithDate: processedData };
    },
    setCurrentQuarter: (state, action) => {
      return { ...state, selectedQuarter: action.payload };
    },
    setCurrentYear: (state, action) => {
      return { ...state, selectedYear: action.payload };
    },
    setComparisonQuarter: (state, action) => {
      return { ...state, comparisonQuarter: action.payload };
    },
    setComparisonYear: (state, action) => {
      return { ...state, comparisonYear: action.payload };
    },
    getCurrentQuarter: (state, action) => {
      const quarterValue = TransformDate.getCurrentQuarter(action.payload);
      return { ...state, selectedQuarter: quarterValue };
    },
    getCurrentYear: (state, action) => {
      const yearValue = TransformDate.getCurrentYear(action.payload);
      return { ...state, selectedYear: yearValue };
    },
    getCompareCurrentQuarter: (state, action) => {
      const quarterValue = TransformDate.getCurrentQuarter(action.payload);
      return { ...state, comparisonQuarter: quarterValue };
    },
    getCompareCurrentYear: (state, action) => {
      const yearValue = TransformDate.getCurrentYear(action.payload);
      return { ...state, comparisonYear: yearValue };
    },
    getQuarterList: (state, action) => {
      const items = action.payload;
      const quarterData = TransformDate.getQuarterData(
        items.quarter,
        items.year,
        items.transformedData
      );
      state.quarterList = quarterData;
    },
    getQuarterListForCompare: (state, action) => {
      const items = action.payload;
      const quarterData = TransformDate.getQuarterData(
        items.quarter,
        items.year,
        items.transformedData
      );
      state.quarterCompareList = quarterData;
    },
    updateQuarterYearMenuList: (state, action) => {
      const menuList = TransformDate.getMenuItemsForQuarterAndYear(action.payload);
      state.quarterMenuList = menuList.quarters;
      state.yearMenuList = menuList.years;
    },
    updateQuarterYearMenuListForCompare: (state, action) => {
      const menuList = TransformDate.getMenuItemsForQuarterAndYear(action.payload);
      state.quarterMenuListForCompare = menuList.quarters;
      state.yearMenuListForCompare = menuList.years;
    },
    moveBackward: (state, action) => {
      const items = action.payload;
      const { newQuarter, newYear } = TransformDate.moveToPrevious(
        items.quarter,
        items.year,
        items.startingYear
      );
      state.selectedQuarter = newQuarter;
      state.selectedYear = newYear;
    },
    moveForward: (state, action) => {
      const items = action.payload;
      const { newQuarter, newYear } = TransformDate.moveToNext(
        items.quarter,
        items.year,
        items.endingYear,
        items.endingQuarter
      );
      state.selectedQuarter = newQuarter;
      state.selectedYear = newYear;
    },
    moveBackwardForCompare: (state, action) => {
      const items = action.payload;
      const { newQuarter, newYear } = TransformDate.moveToPrevious(
        items.quarter,
        items.year,
        items.startingYear
      );
      state.comparisonQuarter = newQuarter;
      state.comparisonYear = newYear;
    },
    moveForwardForCompare: (state, action) => {
      const items = action.payload;
      const { newQuarter, newYear } = TransformDate.moveToNext(
        items.quarter,
        items.year,
        items.endingYear,
        items.endingQuarter
      );
      state.comparisonQuarter = newQuarter;
      state.comparisonYear = newYear;
    },
    updateBoundaryValues: (state, action) => {
      const { startingYear, endingYear, endingQuarter } = TransformDate.getBoundaryValues(
        action.payload
      );
      state.boundaryValue.startingYear = startingYear;
      state.boundaryValue.endingYear = endingYear;
      state.boundaryValue.endingQuarter = endingQuarter;
    },
    updateBoundaryValuesForCompare: (state, action) => {
      const { startingYear, endingYear, endingQuarter } = TransformDate.getBoundaryValues(
        action.payload
      );
      state.boundaryValueForCompare.startingYear = startingYear;
      state.boundaryValueForCompare.endingYear = endingYear;
      state.boundaryValueForCompare.endingQuarter = endingQuarter;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCalendarData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCalendarData.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.userData = payload;
        localStorage.setItem('calendarData', JSON.stringify(state.userData));
      })
      .addCase(getCalendarData.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});

export const calendarActions = calendarSlice.actions;

export default calendarSlice.reducer;
